import {Injectable} from '@angular/core';

declare const Sfdc: any;

@Injectable({
    providedIn: 'root'
})
export class SalesforceService {
    client: { instanceId: string|null, oauthToken: string|null, targetOrigin: string|null };

    constructor() {
        if (localStorage.getItem('canvasInstanceId')) {
            this.client = {
                instanceId: localStorage.getItem('canvasInstanceId'),
                oauthToken: localStorage.getItem('canvasOauthToken'),
                targetOrigin: localStorage.getItem('canvasTargetOrigin'),
            }
        }
    }

    resize(newHeight: number) {
        if (newHeight !== 0 && newHeight !== Sfdc.canvas.client.size(this.client).heights.contentHeight) {
            console.log('Setting new canvas height', newHeight);
            Sfdc.canvas.client.resize(this.client, {height: newHeight + 'px', width: '100%'});
        }
    }

    isCanvas() {
        return false
    }
}
